import { render, staticRenderFns } from "./EditFaqPage.vue?vue&type=template&id=d6384050"
import script from "./EditFaqPage.vue?vue&type=script&lang=js"
export * from "./EditFaqPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports